import { render, staticRenderFns } from "./cabUse.vue?vue&type=template&id=5190672c&"
import script from "./cabUse.vue?vue&type=script&lang=js&"
export * from "./cabUse.vue?vue&type=script&lang=js&"
import style0 from "./cabUse.vue?vue&type=style&index=0&id=5190672c&prod&lang=less&rel=stylesheet%2Fless&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports